import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { StorageService } from '../../../services/commons/storage.service';
import { GlobalVariablesService } from '../../../services/global-variables.service';
import { AppUserHomeRequest } from '../../../services/SicorService/RequestObject/AppUserHomeRequest';
import { MaintenanceService } from '../../../services/commons/maintenance.service';
import { IncidenceType } from '../../../models/IncidenceType';
import { SubmitIncidence } from '../../../services/SicorService/RequestObject/SubmitIncidence';
import { TranslateConfigService } from 'src/app/services/commons/translate-config.service';
import { NavigationService } from '../../../services/commons/navigation.service';
import { GlobalMethodsService } from '../../../services/global-methods.service';
import { DefaultModalComponent } from '../default-modal/default-modal.component';
import { FirebaseCrashlytics } from '@capacitor-community/firebase-crashlytics';

@Component({
  selector: 'app-report-failure',
  templateUrl: './report-failure.component.html',
  styleUrls: ['./report-failure.component.scss'],
})
export class ReportFailureComponent implements OnInit {

  public failureForm: FormGroup;
  public user: string;
  public submitRequestParams: SubmitIncidence;
  public requestParams: AppUserHomeRequest;
  public incidenceTypes: IncidenceType[] = [];
  public isServiceBusy = false;

  constructor(private modalCtrl: ModalController,
    private formBuilder: FormBuilder,
    private storage: StorageService,
    public gvs: GlobalVariablesService,
    public maintenanceService: MaintenanceService,
    private translate: TranslateConfigService,
    private navigation: NavigationService,
    private defaultModalComponent: DefaultModalComponent,
    public gms: GlobalMethodsService,) { }

  async ngOnInit() {
    this.failureForm = this.formBuilder.group({
      device: new FormControl('', [Validators.required]),
      incidence: new FormControl('', [Validators.required, Validators.maxLength(60)])
    });
    this.user = this.gvs.user.userName;
    await this.getIncidenceTypes();
  }

  ionViewWillEnter(){
    this.gms.analyticsTrackEvent('openScreen', {screenName: 'Nueva Averia', contentGroup: 'Mantenimientos'}); 
  }

  async getIncidenceTypes() {
    const checkInternet = await this.gms.checkInternet();
    if (checkInternet) {

      this.requestParams = {
        user: this.user,
        s_ins: this.gvs.currentInstallation.s_ins
      };
      try {
        this.incidenceTypes = await this.maintenanceService.getIncidenceType(this.requestParams);
        if (this.incidenceTypes === undefined) {
          await this.dismiss(null);
        }
        else if (this.incidenceTypes.length === 0 || this.incidenceTypes === null) {
          await this.dismiss(false);
          await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.notFoundIncidenceceData'),
            'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
        }
      }
      catch (e) {
        const message = JSON.stringify(e);
        await FirebaseCrashlytics.recordException({message: message});
        await this.dismiss(false);
        await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.notFoundIncidenceceData'),
          'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
      }
    } else {
      await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
        'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
    }
  }

  dismiss(value) {
    this.modalCtrl.dismiss({ result: value });
  }

  public async onSubmit() {
    if (this.isServiceBusy) {
      return;
    }
    this.gms.analyticsTrackEvent('report_failure', {eventCategory: 'SICOR/Reporte Incidencia', eventAction: 'Accion/Enviar Click'});
    if (this.failureForm.valid) {
      const checkInternet = await this.gms.checkInternet();
      if (checkInternet) {
        await this.gms.loading();
        this.isServiceBusy = true;
        this.failureForm = this.gms.checkAllowedCharacters(this.failureForm);
        this.submitRequestParams = {
          user: this.user,
          s_ins: this.gvs.currentInstallation.s_ins,
          contact: this.gvs.currentInstallation.user_name,
          prbl: this.failureForm.value.device,
          text: this.failureForm.value.incidence
        };
        try {
          await this.maintenanceService.sendIncidence(this.submitRequestParams);
          this.modalCtrl.dismiss(false, '', 'loadSpinner');
          this.modalCtrl.dismiss(false, '', 'reportFailureModal');
        }
        catch (e) {
          const message = JSON.stringify(e);
        await FirebaseCrashlytics.recordException({message: message});
          this.modalCtrl.dismiss(false, '', 'loadSpinner');
          await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.incidenceMessageNotSent'),
            'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
        }
        this.isServiceBusy = false;
      } else {
        await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.noInternetConnection'),
          'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
      }
    } else {
      this.validateAllFormFields(this.failureForm);
    }
  }

  isFieldValid(field: string) {
    return !this.failureForm.get(field).valid && this.failureForm.get(field).touched;
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (!control.valid){
        this.gms.analyticsTrackEvent('form_error', {eventCategory: 'SICOR/Reporte Incidencia', eventAction: 'Error/Form: Reportar Incidencia', eventLabel:'Campo: ' + field});
      }
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

}
